import { EUiTagTag, type TUiTagOption } from '@experience/core-tag-ui';
import type { LocationQueryRaw } from 'vue-router';
import type { ExtendedForChipsTagType } from '@/entities/rubrics';
import { buildRubricTagRoute } from '@/entities/rubrics/lib/buildRubricTagRoute';

export type MoreRubricTag = {
  label: string;
  value: string;
  isMoreButton: true;
};

export type PopupRubricTag = ExtendedForChipsTagType | MoreRubricTag;

export const isMoreRubricTag = (tag: PopupRubricTag): tag is MoreRubricTag => {
  return 'isMoreButton' in tag;
};

export const mapPopupRubricsToTagOptions = (
  tags: PopupRubricTag[],
  selectedSlug: string,
  filterQuery: LocationQueryRaw,
): TUiTagOption[] => {
  return tags.map((tag) => {
    if (isMoreRubricTag(tag)) {
      return {
        label: tag.label,
        as: EUiTagTag.SPAN,
        isSelected: false,
      };
    }

    const route = buildRubricTagRoute(tag.url, filterQuery);

    return {
      label: tag.label || tag.name || '',
      counter: tag.counter,
      to: route,
      as: route ? EUiTagTag.ROUTER_LINK : EUiTagTag.SPAN,
      isSelected: tag.value === selectedSlug,
      ...(tag.id !== undefined ? { id: String(tag.id) } : {}),
    };
  });
};
